module.exports = __webpack_public_path__ + "img/album17_15.5a992514.jpg";